import { useInitProviders } from "../hooks/useInitProviders";
import { UserInfo } from "../types";

function AuthInitProviders({
  userInfo,
  children,
}: {
  userInfo: UserInfo;
  children: React.ReactNode;
}) {
  useInitProviders(userInfo);

  return children;
}

export default AuthInitProviders;
